import React from 'react';
import { Star } from 'lucide-react';
import { testimonials, businessInfo } from '../data/mock';
import { useLanguage } from '../context/LanguageContext';
import Reveal from './motion/Reveal';

const Reviews = () => {
  const { t } = useLanguage();

  return (
    <section id="reviews" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <Reveal className="text-center max-w-3xl mx-auto mb-16 space-y-4">
          <div className="inline-flex items-center space-x-3 bg-white px-6 py-3 shadow-sm">
            <div className="flex items-center space-x-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={20} className="fill-gray-900 text-gray-900" />
              ))}
            </div>
            <span className="text-2xl font-normal text-gray-900">{businessInfo.rating}</span>
          </div>

          <h2 className="text-4xl font-normal text-gray-900">
            {t.reviews.title}
          </h2>
          <div className="w-16 h-px bg-gray-900 mx-auto"></div>
          <p className="text-lg text-gray-600">
            {t.reviews.rating}
          </p>
        </Reveal>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div 
              key={testimonial.id}
              className="bg-white p-8 hover:shadow-lg transition-all duration-200"
            >
              <div className="space-y-6">
                {/* Stars */}
                <div className="flex items-center space-x-1">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} size={16} className="fill-gray-900 text-gray-900" />
                  ))}
                </div>

                {/* Review text */}
                <p className="text-sm text-gray-600 leading-relaxed">
                  "{testimonial.text}"
                </p>

                {/* Author info */}
                <div className="pt-4 border-t border-gray-200 space-y-1">
                  <div className="text-sm font-normal text-gray-900">
                    {testimonial.name}
                  </div>
                  <div className="text-xs text-gray-500">
                    {testimonial.service}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Call to action */}
        <div className="text-center mt-12">
          <a 
            href="https://www.google.com/search?q=colombian+body+med+spa+garland"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center space-x-2 text-sm text-gray-900 hover:text-gray-600 transition-colors duration-200"
          >
            <span>Read more reviews on Google</span>
            <span>→</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
